module.exports = {
  DEV: {
    newrelicApplicationId: '1120527014',
    newrelicLicenseKey: 'NRBR-023642f2789bb6a2349',
    newrelicAccountId: '4394941',
    newrelicTrustKey: '4139912',
  },
  UAT: {
    newrelicApplicationId: '1120527013',
    newrelicLicenseKey: 'NRBR-023642f2789bb6a2349',
    newrelicAccountId: '4394941',
    newrelicTrustKey: '4139912',
  },
  PRD: {
    newrelicApplicationId: '1120527012',
    newrelicLicenseKey: 'NRBR-023642f2789bb6a2349',
    newrelicAccountId: '4394941',
    newrelicTrustKey: '4139912',
  },
};